import { makeTransitionComponent } from './makeTransitionComponent';

export const TransitionZoomIn = makeTransitionComponent((timeout) => ({
    default: {
        opacity: 0,
        transform: 'scale(0.5)',
        transitionDelay: '0ms',
        transitionDuration: `${timeout}ms`,
        transitionTimingFunction: 'cubic-bezier(0, 0, 0.2, 1)',
        transitionProperty: 'transform, opacity',
    },
    entering: { transform: 'scale(0.5)', opacity: 0 },
    entered: { transform: 'translateY(0)', opacity: 1 },
}));
